export const darkModeKey = "darkMode";
export const styleKey = "style";
export const containerMaxW = "xl:max-w-full xl:mx-4";

/* global __CF_STAGING_API_BASE__ */
const stagingBase =
  typeof __CF_STAGING_API_BASE__ !== "undefined" ? __CF_STAGING_API_BASE__ : "";

let BASE_URL = import.meta.env.VITE_API_BASE_URL || "";

if (stagingBase) {
  // Cloudflare preview for a staging/* branch -> its ephemeral backend.
  BASE_URL = stagingBase;
} else if (import.meta.env.PROD) {
  // Production build (master) -> prod backend.
  BASE_URL = "https://api.buzztracker.co.za";
}

export { BASE_URL };
